import React, { useEffect, memo } from "react"
import AOS from "aos"
import parse from "html-react-parser"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import "aos/dist/aos.css"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import { appNavigate } from "../../../utils/functions"
import LinkButtonRed from "../../buttons/linkButtonRed/linkButtonRed"
import * as style from "./expertise.module.css"

const Expertise = ({
  CustomClass,
  homeDomainTitle,
  homeDomainContent,
  homeDomainShowSection,
  homeDomainSubTitle,
  homeDomainImageTextList,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {homeDomainShowSection === "yes" && (
        <section
          // className={style.expertise}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className="row">
              <div className={style.expertise_wrap}>
                <SectionsTitle
                  title={homeDomainTitle}
                  SubTitle={homeDomainSubTitle}
                  Content={homeDomainContent}
                  styleCss={{ display: "none" }}
                />
                <ul className={style.expertise_listing}>
                  {homeDomainImageTextList?.map((item, index) => {
                    return (
                      <li key={index}>
                        <a
                          className={style.expertiseBox}
                          onClick={e => {
                            e.preventDefault()
                            appNavigate(`${item?.homeDomainListLink?.url}`)
                          }}
                          href={`${item?.homeDomainListLink?.url}`}
                        >
                          <OptimizedImage
                            imageData={
                              item?.homeDomainListImage?.mediaItemUrl
                                ? item?.homeDomainListImage?.mediaItemUrl
                                : "/images/placeholder-image.jpg"
                            }
                            alt={item?.homeDomainListImage?.altText}
                          />
                          <div className={style.TitleBox}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <i className={style.icon}>
                                {" "}
                                {parse(`${item.homeDomainListIcon}`)}{" "}
                              </i>
                              <h3> {item?.homeDomainListTitle} </h3>
                            </div>
                            <LinkButtonRed
                              btnText=""
                              linkTo={item?.homeDomainListLink?.url}
                            />
                          </div>
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(Expertise)
